import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Whenever route changes, jump to top of the page.
 * Used as a sibling to Routes so every navigation resets scroll.
 */
const ScrollToTopOnRoute = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        // ignore in-page anchors (e.g. /#hotels)
        if (window.location.hash) return;
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }, [pathname]);
    return null;
};

export default ScrollToTopOnRoute;
